import { useMediaQuery } from "react-responsive";

export const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 1024 });
  return isDesktop ? children : null;
};

export const TabletOrDesktop = ({ children }) => {
  const isTabletOrDesktop = useMediaQuery({ minWidth: 768 });
  return isTabletOrDesktop ? children : null;
};

export const MobileOrDesktop = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isDesktop = useMediaQuery({ minWidth: 1024 });

  return isMobile || isDesktop ? children : null;
};

export const MobileOrTablet = ({ children }) => {
  const isMobileOrTablet = useMediaQuery({ maxWidth: 1023 });
  return isMobileOrTablet ? children : null;
};

export const Tablet = ({ children }) => {
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1023 });
  return isTablet ? children : null;
};

export const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return isMobile ? children : null;
};

const ResponsiveComponent = {
  Desktop,
  TabletOrDesktop,
  MobileOrDesktop,
  MobileOrTablet,
  Tablet,
  Mobile,
};

export default ResponsiveComponent;
